import { Tooltip } from "@material-tailwind/react";
import { Info } from "lucide-react";
import React, { forwardRef } from "react";

const CustomInput = forwardRef(
  (
    {
      label,
      name,
      textarea = false,
      type = "text",
      required = false,
      className = "",
      showInfo = false,
      infoText = "",
      error,
      endAdornment,
      ...props
    },
    ref
  ) => {
    // When an end-adornment (eye toggle, clear button, etc.) is provided we
    // pad the input on the right so the field text doesn't slide under it.
    const inputClasses = `w-full px-2 py-2 ${endAdornment ? "pr-10" : ""} border ${
      error ? "border-red-500" : "border-slate-300"
    } rounded-md focus:border-flamingo-500 focus:ring-0 focus:outline-none transition-colors duration-200 text-sm`;

    const inputEl = textarea ? (
      <textarea ref={ref} className={inputClasses} name={name} {...props} />
    ) : (
      <input
        ref={ref}
        className={inputClasses}
        type={type}
        name={name}
        placeholder={label}
        {...props}
      />
    );

    return (
      <div className={`w-full overflow-hidden ${className}`}>
        {label && (
          <label className="flex text-sm font-normal text-slate-500 mb-1 text-nowrap items-center gap-1">
            {label}{" "}
            {required ? (
              <span className="text-red-500 text-xl">*</span>
            ) : (
              <span className="text-xl">&nbsp;</span>
            )}
            {showInfo ? (
              <Tooltip placement="right">
                <Tooltip.Trigger>
                  <Info className="size-4" />{" "}
                </Tooltip.Trigger>
                <Tooltip.Content className="bg-white text-slate-500 text-sm font-normal border border-slate-300 w-72">
                  {infoText}
                  <Tooltip.Arrow />
                </Tooltip.Content>
              </Tooltip>
            ) : null}
          </label>
        )}
        {endAdornment ? (
          // Relative wrapper sized to the input so the adornment lands
          // vertically centred regardless of whether an error row appears
          // below — no more `bottom-9` magic numbers.
          <div className="relative">
            {inputEl}
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 text-gray-500">
              {endAdornment}
            </div>
          </div>
        ) : (
          inputEl
        )}
        {typeof error === "string" && error ? (
          <p className="mt-1 text-xs text-red-500">{error}</p>
        ) : null}
      </div>
    );
  }
);

CustomInput.displayName = "CustomInput";

export default CustomInput;
